import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CalendarClock } from "lucide-react";
import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Proof } from "../components/site/Proof";
import { Services } from "../components/site/Services";
import { Cases } from "../components/site/Cases";
import { WhyMe } from "../components/site/WhyMe";
import { Process } from "../components/site/Process";
import { Pricing } from "../components/site/Pricing";
import { Faq } from "../components/site/Faq";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";
import { BookingModal } from "../components/site/BookingModal";
import { track } from "../lib/api";

export default function Landing() {
  const [booking, setBooking] = useState(false);
  const [showFab, setShowFab] = useState(false);

  const openBooking = () => {
    track("book_click");
    setBooking(true);
  };

  useEffect(() => {
    const onScroll = () => setShowFab(window.scrollY > 700);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="relative">
      <Nav onBook={openBooking} />
      <main>
        <Hero onBook={openBooking} />
        <Marquee />
        <Proof />
        <Services onBook={openBooking} />
        <Cases onBook={openBooking} />
        <WhyMe />
        <Process />
        <Pricing onBook={openBooking} />
        <Faq />
        <Contact onBook={openBooking} />
      </main>
      <Footer onBook={openBooking} />

      <BookingModal open={booking} onOpenChange={setBooking} />

      <AnimatePresence>
        {showFab && (
          <motion.button
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 30 }}
            transition={{ duration: 0.35 }}
            onClick={openBooking}
            data-testid="persistent-book-fab"
            className="fixed bottom-5 right-5 z-40 md:hidden inline-flex items-center gap-2 rounded-full bg-[var(--magenta)] text-white font-semibold px-5 py-3.5 magenta-glow"
          >
            <CalendarClock size={18} />
            Agendar
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
}
